import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import "./Coffee.scss";

import {
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Popover,
} from "@material-ui/core";
import moment from "moment";
import { FormatHelper } from "../../helpers";
import { TimePickerService } from "../../services/TimePicker";
import { useLocalStorage } from "../../shared/LocalStorageHook";
import StripeLogo from "../../shared/icons/stripe-logo.png";
import Spinner from "../spinner";

import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { MdOutlineWatchLater } from "react-icons/md";
import DatePicker from "react-mobile-datepicker";
import { StripeService } from "../../services/Stripe";
import { MeetingTypes } from "../../shared/MeetingTypes";
import { PaymentTypes } from "../../shared/PaymentTypes";
import {
  APP_DOMAIN,
  MOBILE_WIDTH,
  ZOOM_CLIENT_ID,
} from "../../shared/constants";
import AmericanHeartPreview from "../../shared/icons/American Heart Association.png";
import AssutaPreview from "../../shared/icons/Assuta-EN.png";
import ChaiLifelinePreview from "../../shared/icons/Chai Lifeline.png";
import ChildFundPreview from "../../shared/icons/ChildFund International.png";
import EntertainmentIndustryPreview from "../../shared/icons/Entertainment Industry Foundation.png";
import FIDFPreview from "../../shared/icons/FIDF.png";
import KidsKickingCancerPreview from "../../shared/icons/Kids Kicking Cancer.png";
import LatetPreview from "../../shared/icons/Latet.png";
import MagenPreview from "../../shared/icons/Magen David Adom.png";
import MichaelJFoxPreview from "../../shared/icons/Michael J Fox Foundation for Parkinson.png";
import MountSinaiPreview from "../../shared/icons/Mount Sinai Health Systems.png";
import OneFamilyFundPreview from "../../shared/icons/One Family Fund.png";
import ShrinersPreview from "../../shared/icons/Shriners Hospitals for Children.png";
import StandWithUsPreview from "../../shared/icons/Stand with Us.png";
import UnitedHatzalaPreview from "../../shared/icons/United Hatzala.png";
import PitchonPreview from "../../shared/icons/pitchon_lev.png";
import ZoomLogo from "../../shared/icons/zoom-logo.png";
import useWindowDimensions from "../../shared/windowResize";
import Switcher from "../switcher";
import GetPaid from "./GetPaid";

const MAX_LENGTH = {
  description: 100,
};

export const causes = [
  {
    title: "One Family Fund",
    image: OneFamilyFundPreview,
  },
  {
    title: "Assuta Hospital",
    image: AssutaPreview,
  },
  {
    title: "Mount Sinai Health System",
    image: MountSinaiPreview,
  },
  {
    title: "United Hatzalah",
    image: UnitedHatzalaPreview,
  },
  {
    title: "FIDF",
    image: FIDFPreview,
  },

  {
    title: "StandWithUs",
    image: StandWithUsPreview,
  },
  {
    title: "Latet",
    image: LatetPreview,
  },

  {
    title: "Pitchon Lev",
    image: PitchonPreview,
  },
  {
    title: "Magen David Adom",
    image: MagenPreview,
  },
  {
    title: "American Heart Association",
    image: AmericanHeartPreview,
  },
  {
    title: "Chai Lifeline",
    image: ChaiLifelinePreview,
  },
  {
    title: "ChildFund International",
    image: ChildFundPreview,
  },
  {
    title: "Entertainment Industry Foundation",
    image: EntertainmentIndustryPreview,
  },
  {
    title: "Kids Kicking Cancer",
    image: KidsKickingCancerPreview,
  },
  {
    title: "Michael J. Fox Foundation for Parkinson",
    image: MichaelJFoxPreview,
  },

  {
    title: "Shriners Hospitals for Children",
    image: ShrinersPreview,
  },
];

const CoffeeForm = (props) => {
  const {
    setTitle,
    user,
    setSignInPageStatus,
    signInPageStatus,
    setUserInfo,
  } = props;

  useEffect(() => {
    if (signInPageStatus) {
      return;
    }

    setTitle("FundraiserTalk");
    // eslint-disable-next-line
  }, []);

  const [charactersLeft, setCharactersLeft] = useState({
    description: MAX_LENGTH.description,
  });

  const [formValue, setFormValue] = useState(() => {
    let timeFrom = TimePickerService.getCurrentTime();
    let timeTo = moment(timeFrom * 1000)
      .add(1, "hour")
      .unix();

    return {
      description: "",
      duration_time: 60,
      time_from: timeFrom,
      time_to: timeTo,
      payment_type: PaymentTypes.FUNDRAISER,
      payment_amount: 0,
      type: MeetingTypes.LIVE,
    };
  });

  const [invalidTime, setInvalidTime] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [anchorEl, setAnchorEl] = useState(false);
  const [errors, setErrors] = useState({});

  const [localStorageCoffee, setLocalStorageCoffee] = useLocalStorage(
    "coffee",
    null
  );
  const { screenWidth } = useWindowDimensions();

  const isMobileDevice = screenWidth < MOBILE_WIDTH;
  const [chargesEnabled, setChargesEnabled] = useState(false);
  const [shownCauses, setShownCauses] = useState(
    causes.slice(0, isMobileDevice ? 4 : 8)
  );

  // eslint-disable-next-line no-undef
  const zoomHref = `https://zoom.us/oauth/authorize?client_id=${ZOOM_CLIENT_ID}&response_type=code&redirect_uri=${APP_DOMAIN}/zoom`;

  const { register, handleSubmit } = useForm();

  useEffect(() => {
    if (localStorageCoffee !== null) {
      setFormValue(localStorageCoffee);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!user.stripeId) {
      return;
    }

    StripeService.getAccountData(user.stripeId)
      .then((res) => {
        if (res.charges_enabled) {
          setChargesEnabled(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [user]); // eslint-disable-line

  const setFormField = (event, name) => {
    const formValueFromEvent = event.target.value;
    if (name === "description") {
      const validCharactersIsLeft =
        MAX_LENGTH[name] - formValueFromEvent.length;

      if (validCharactersIsLeft < 0) {
        return;
      }

      setCharactersLeft({
        ...charactersLeft,
        [name]: validCharactersIsLeft,
      });
    }

    setFormValue({ ...formValue, [name]: formValueFromEvent });
  };

  const validateOnCreate = () => {
    const foundErrors = {};

    if (!formValue["description"]) {
      foundErrors["description"] = "Field is required.";
    }

    setErrors((err) => {
      return { ...err, ...foundErrors };
    });
  };

  const createCoffee = async () => {
    try {
      setIsLoading(true);

      if (!user.id) {
        setSignInPageStatus(true);
        return;
      }

      if (
        formValue.type === MeetingTypes.LIVE &&
        formValue.payment_amount !== 0
      ) {
        goLive();
        return;
      }

      validateOnCreate();
      const coffeeReqObj = FormatHelper.getZoomFormValue(formValue);

      if (!coffeeReqObj) {
        return;
      }

      const timeTo = moment(formValue.time_from * 1000)
        .add(formValue.duration_time, "minutes")
        .unix();

      const formData = {
        ...formValue,
        time_to: timeTo,
      };

      setLocalStorageCoffee(formData);
      window.location.assign(zoomHref);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDateChange = (date) => {
    const isOldDate = moment(date).isBefore(moment());

    if (isOldDate) {
      const timeFrom = TimePickerService.getCurrentTime();
      const timeTo = moment(timeFrom * 1000)
        .add(1, "hour")
        .unix();

      setFormValue({
        ...formValue,
        time_from: timeFrom,
        time_to: timeTo,
      });
      return;
    }

    const hoursDiff = moment(date).diff(formValue.time_from * 1000, "hours");

    const dayDiff = hoursDiff / 24;
    const roundedDaysDiff = Math.ceil(dayDiff);

    const updatedTimeFrom = moment(formValue.time_from * 1000)
      .add(roundedDaysDiff, "days")
      .unix();

    const updatedTimeTo = moment(formValue.time_to * 1000)
      .add(roundedDaysDiff, "days")
      .unix();

    setFormValue({
      ...formValue,
      time_from: updatedTimeFrom,
      time_to: updatedTimeTo,
    });
  };

  const getTimeIn12hFormat = (date) => {
    return moment(date * 1000).format("h:mm A");
  };

  const daysRange = (date) => {
    const diff = moment(date).diff(moment(), "days");
    return diff > 13 || diff < 0;
  };

  const formatAMPM = (date) => {
    let hours = date.getHours();
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    return hours;
  };

  const dateConfig = {
    hour: {
      format: (value) => formatAMPM(value),
      // format: "hh",
      caption: "Hour",
      step: 1,
    },
    minute: {
      format: "mm",
      caption: "Min",
      step: 15,
    },
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onSelectTime = (time) => {
    const newTime = moment(time).unix();

    if (newTime < moment().unix()) {
      setInvalidTime(true);
      setTimeout(() => setInvalidTime(false), 1000);
      return;
    }

    const isNotCurrentDate =
      moment(newTime * 1000).unix() >
      moment(formValue.time_from * 1000)
        .set("hours", 23)
        .set("minutes", 0)
        .set("seconds", 0)
        .unix();

    if (isNotCurrentDate) {
      setInvalidTime(true);
      setTimeout(() => setInvalidTime(false), 1000);
      return;
    }

    const timeTo = moment(newTime * 1000)
      .add(1, "hour")
      .unix();

    setFormValue({ ...formValue, time_from: newTime, time_to: timeTo });
  };

  const getPickerValue = () => {
    return moment(formValue.time_from * 1000).toDate();
  };

  const getZoomSubmitContent = () => {
    if (formValue.type === MeetingTypes.LIVE) {
      return "Go Live";
    }

    return "Schedule";
  };

  const onTextAreaChange = (e, field) => {
    setFormField(e, field);
    validateText(e, field);
  };

  const validateText = (e, field) => {
    const value = e.target.value;
    if (!value) {
      setErrors((err) => {
        return { ...err, [field]: "Field is required." };
      });
      return;
    }

    const updatedErrors = errors;
    delete updatedErrors[field];
    setErrors(updatedErrors);
  };

  const goLive = () => {
    if (!formValue["description"]) {
      setErrors((err) => {
        return { ...err, description: "Field is required." };
      });
      return;
    }

    const timeFrom = moment(TimePickerService.getRoundedTime()).unix();
    const timeTo = moment(timeFrom * 1000)
      .add(1, "h")
      .unix();

    const data = {
      description: formValue.description,
      duration_time: 60,
      time_from: timeFrom,
      time_to: timeTo,
      payment_amount: formValue.payment_amount,
      payment_type: formValue.payment_type,
      type: MeetingTypes.LIVE,
    };

    setFormValue(data);

    setLocalStorageCoffee(data);
    window.location.assign(zoomHref);
  };

  const onLiveSwitcherChange = (e) => {
    if (e.target.checked) {
      setFormValue({ ...formValue, type: MeetingTypes.LIVE });
      return;
    }
    setFormValue({ ...formValue, type: MeetingTypes.ZOOM_GROUP });
  };

  const onCauseUpdate = (causeText) => {
    setFormValue({
      ...formValue,
      description: causeText,
    });
  };

  const showMoreOrLess = () => {
    if (shownCauses.length < causes.length) {
      setShownCauses(causes);
    } else {
      setShownCauses(causes.slice(0, isMobileDevice ? 4 : 8));
    }
  };

  const liveNow = formValue.type === MeetingTypes.LIVE;
  const pickerOpen = Boolean(anchorEl);

  return (
    <React.Fragment>
      {isLoading && (
        <Spinner loaderContainerName="loader-container" blockName="modal" />
      )}
      <form onSubmit={handleSubmit(createCoffee)}>
        <div className="description">
          <Grid
            container
            justifyContent="space-between"
            alignItems="flex-start"
            direction="column"
            className="first-question"
          >
            <h2>Pick a cause to fundraise for</h2>

            <div className="cause-container">
              {shownCauses.map((c) => (
                <div
                  className={formValue.description === c.title ? "active" : ""}
                  key={c.title}
                  onClick={() => onCauseUpdate(c.title)}
                >
                  <img src={c.image} alt="preview" />
                  {/* <button
                    onClick={(e) => e.stopPropagation()}
                    className="cause-button"
                  >
                    Follow
                  </button> */}
                </div>
              ))}
            </div>

            {/*<p>I would like to talk about</p>*/}
          </Grid>

          {/*<textarea*/}
          {/*  ref={register}*/}
          {/*  value={formValue.description}*/}
          {/*  onChange={e => onTextAreaChange(e, 'description')}*/}
          {/*  name="description"*/}
          {/*  placeholder=""*/}
          {/*  className={errors['description'] && 'error'}*/}
          {/*/>*/}
          {/*{errors['description'] && <div className="validation">{errors['description']}</div>}*/}

          <div className="characters-left-container">
            <p className="characters-left" onClick={showMoreOrLess}>
              Tap to see {shownCauses.length < causes.length ? "more" : "less"}
            </p>
          </div>
        </div>

        <div className="time-selector">
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            className="swith-container"
          >
            <p className="bold-text simple" style={{ fontSize: "18px" }}>
              When would you like to start?
            </p>

            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div className="zoom-logo-container">
                <div>Go Live With</div>
                <img src={ZoomLogo} alt="preview" />
              </div>
              <Switcher
                className="switcher"
                checked={formValue.type === MeetingTypes.LIVE}
                onChange={onLiveSwitcherChange}
              />
            </Grid>
          </Grid>

          {!liveNow && (
            <>
              <div className="zoom-date-picker">
                <Grid className="zoom-date" container direction="column">
                  <span className="name">Date:</span>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      shouldDisableDate={daysRange}
                      disableToolbar
                      variant="inline"
                      format="MMMM dd, yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      value={formValue.time_from * 1000}
                      onChange={handleDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      disabled={liveNow}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid container direction="column">
                  <span className="name">Start time:</span>
                  <div className="search-container">
                    <div id={invalidTime ? "anim-error" : "error"}>
                      <Input
                        onClick={(e) => {
                          if (!liveNow) {
                            handleClick(e);
                          }
                        }}
                        type={"text"}
                        value={getTimeIn12hFormat(formValue.time_from)}
                        className={errors["time"] && "error"}
                        endAdornment={
                          <InputAdornment position="end" disabled={liveNow}>
                            <IconButton edge="end" disabled={liveNow}>
                              <MdOutlineWatchLater />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </div>

                    {errors["time"] && (
                      <div className="validation">{errors["time"]}</div>
                    )}
                  </div>
                </Grid>
              </div>
            </>
          )}
          <div className="set-minimum-donation bold-text simple">Set minimum donation</div>
          <GetPaid
            setFormValue={setFormValue}
            formValue={formValue}
            user={user}
            setUserInfo={setUserInfo}
            chargesEnabled={chargesEnabled}
            setSignInPageStatus={setSignInPageStatus}
          />
          <div className="top-donors">
            10 largest donors get to talk with you, the rest are on mute.
          </div>
          <img src={StripeLogo} alt="preview" className="stripe-logo" />

          <Popover
            open={pickerOpen}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            PaperProps={{
              style: { width: "274px", height: "200px", marginTop: "-9px" },
            }}
          >
            <DatePicker
              value={getPickerValue()}
              isOpen={true}
              theme="ios"
              isPopup={false}
              showHeader={true}
              showFooter={true}
              dateConfig={dateConfig}
              onChange={onSelectTime}
            />
          </Popover>
        </div>

        <div className="create-button-container">
          <button
            type="submit"
            className={`${
              FormatHelper.getZoomFormValue(formValue) ? "active" : ""
            }`}
          >
            {getZoomSubmitContent()}
          </button>
        </div>
      </form>
    </React.Fragment>
  );
};

export default CoffeeForm;
